import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';

const Manufacturers = () => {
  const manufacturers = [
    { name: 'ヤマザキマザック', logo: '/images/logos/MAZAC.png', website: 'https://www.mazak.com/jp-ja/' },
    { name: 'DMG MORI', logo: '/images/logos/DMGMORI.png', website: 'https://www.dmgmori.co.jp/' },
    { name: 'OKUMA', logo: '/images/logos/OKUMA.png', website: 'https://www.okuma.co.jp/' },
    { name: 'FANUC', logo: '/images/logos/FANAC.png', website: 'https://www.fanuc.co.jp/index.html' },
    { name: 'ニデックマシンツール', logo: '/images/logos/nidec-machine-tool.png', website: 'https://www.nidec.com/jp/nidec-machinetool/' },
    { name: 'TAKISAWA', logo: '/images/logos/nidec-machine-tool.png', website: 'https://www.takisawa.co.jp/' },
    { name: '岡本工作機械', logo: '/images/logos/okamoto-machine.png', website: 'https://www.okamoto.co.jp/' },
    { name: 'OSG', logo: '/images/logos/osg.png', website: 'https://www.osg.co.jp/' },
    { name: 'KYOCERA', logo: '/images/logos/kyocera.png', website: 'https://www.kyocera.co.jp/prdct/tool/' },
    { name: '日進工具', logo: '/images/logos/NSTOOL.png', website: 'https://www.ns-tool.com/ja/' },
    { name: '三菱マテリアル', logo: '/images/logos/mitsubishi-material.png', website: 'https://www.mmc-carbide.com/jp/products' },
    { name: '岡崎精工', logo: '/images/logos/okazaki-seiko.png', website: 'https://www.okazaki-seiko.co.jp/' },
    { name: 'Tungaloy', logo: '/images/logos/Tungaloy.png', website: 'https://tungaloy.com/jp/' },
    { name: 'MOLDINO', logo: '/images/logos/MOLDINO.png', website: 'https://www.moldino.com/' },
    { name: 'NACHi', logo: '/images/logos/NACHi.png', website: 'https://www.nachi-fujikoshi.co.jp/tool/' },
    { name: '北川鉄工所', logo: '/images/logos/kitagawa.png', website: 'https://www.kiw.co.jp/' },
    { name: 'BIG DAISHOWA', logo: '/images/logos/BIGDAISHOWA.png', website: 'https://www.big-daishowa.co.jp/' },
    { name: 'Mitutoyo', logo: '/images/logos/Mitutoyo.png', website: 'https://www.mitutoyo.co.jp/' },
  ];

  return (
    <section className="py-16 sm:py-24 bg-gradient-to-b from-gray-50 to-blue-100">
      <div className="container mx-auto px-4 sm:px-6">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl sm:text-4xl font-bold text-center text-blue-900 mb-12 sm:mb-16"
        >
          主要取扱いメーカー
        </motion.h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 sm:gap-8">
          {manufacturers.map((manufacturer, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              whileHover={{ scale: 1.05 }}
              className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl"
            >
              <div className="p-4 h-full flex flex-col justify-between">
                <div>
                  <p className="text-sm font-semibold text-blue-900 mb-3 text-center truncate">
                    {manufacturer.name}
                  </p>
                  <div className="flex items-center justify-center h-20 mb-3">
                    <img 
                      src={manufacturer.logo} 
                      alt={`${manufacturer.name} ロゴ`}
                      className="max-h-full max-w-full object-contain"
                      loading="lazy"
                      width="100"
                      height="60"
                    />
                  </div>
                </div>
                <a 
                  href={manufacturer.website} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center justify-center px-3 py-2 bg-blue-600 text-white text-xs font-semibold rounded-full hover:bg-blue-700 transition-colors duration-300"
                  aria-label={`${manufacturer.name}のウェブサイトを開く`}
                >
                  <ExternalLink className="w-4 h-4 mr-1" />
                  ウェブサイト
                </a>
              </div>
            </motion.div>
          ))}
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: manufacturers.length * 0.05 }}
          className="mt-12 sm:mt-16 text-center"
        >
          <p className="text-lg sm:text-xl text-blue-900 font-semibold p-4 sm:p-6 bg-white rounded-xl inline-block shadow-lg">
            他にも多数取扱いございます。お気軽にお問い合わせください。
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Manufacturers;